export default __webpack_public_path__ + "static/media/Apple_Music_Icon_blk_lg_072420.7323bacf.svg";